import { Availability, Cart, SimpleStock, SupplierCart } from '@/types/index'

const isProductUnavailable = (stock: SimpleStock): boolean => {
  return stock.status === Availability.NOT_AVAILABLE || stock.status === Availability.UNKNOWN
}

const isSupplierCart = (cart: Cart | SupplierCart): cart is SupplierCart => {
  return !('supplierCarts' in (cart as SupplierCart))
}

export { isProductUnavailable, isSupplierCart }
